// import Cookies from 'js-cookie';
import Helpers from './Helpers.js';
import countries from './countries.js';
import us_states from './us-states.js';
import canada_provinces from './canada-provinces.js';
import Vue from 'vue';
// import VueRouter from 'vue-router';
// import router from './Router.js';
import VeeValidate, { Validator } from 'vee-validate';
import Loader from './components/Loader.vue';
import DonutChart from './components/DonutChart.vue';
import VueSlider from 'vue-slider-component';

require('es6-promise').polyfill();

Vue.use(VeeValidate, {
    locale: 'en',
    classes: true,
    classNames: {
        // valid: 'is-valid',
        invalid: 'is-invalid'
    },
    // events: 'change',
    events: 'input|blur',
});

Vue.filter('formatNumber', function (value) {
    if (Intl && Intl.NumberFormat) {
        return new Intl.NumberFormat().format(value);
    }
    else return value;
});

var isSuccess = (window.location.search.indexOf('?success') !== -1);

const app = new Vue({
    components: {
        Loader,
        DonutChart,
        VueSlider,
    },
    // router,
    data: {
        env: window.env || 'live', // 'live' or 'test'
        formAction: window.formAction,
        mobileMenuShow: false,
        costOfLabor: 100,
        auditReporting: {
            reports: 50,
            securedObjects: 12,
            minutes: 50,
            minutesOptions: {
                min: 1,
                max: 200,
                height: 12,
                tooltipStyle: {
                    "backgroundColor": "#393f50",
                    "borderColor": "#393f50"
                },
                processStyle: {"backgroundColor": "#2d455d"},
                bgStyle: {"backgroundColor": "#a8b7c6"}
            },
            efficiencyGain: 0.7, 
        },
        rulesChanges: {
            changesPerMonth: 50,
            minutes: 100,
            minutesOptions: {
                min: 1,
                max: 200,
                height: 12,
                tooltipStyle: {
                    "backgroundColor": "#393f50",
                    "borderColor": "#393f50"
                },
                processStyle: {"backgroundColor": "#2d455d"},
                bgStyle: {"backgroundColor": "#a8b7c6"}
            },
            efficiencyGain: 0.94,
        },
        cloudProvisioning: {
            intancesPerMonth: 50,
            minutes: 100,
            minutesOptions: {
                min: 1,
                max: 200,
                height: 12,
                tooltipStyle: {
                    "backgroundColor": "#393f50",
                    "borderColor": "#393f50"
                },
                processStyle: {"backgroundColor": "#2d455d"},
                bgStyle: {"backgroundColor": "#a8b7c6"}
            },
            efficiencyGain: 0.8,
        },
        outages: {
            changeWindowsPerMonth: 100,
            avgOutageWindowMinutes: 100,
            avgOutageWindowMinutesOptions: {
                min: 1,
                max: 200,
                height: 12,
                tooltipStyle: {
                    "backgroundColor": "#393f50",
                    "borderColor": "#393f50"
                },
                processStyle: {"backgroundColor": "#2d455d"},
                bgStyle: {"backgroundColor": "#a8b7c6"}
            },
            avgOutageChangeFailureRecoveryMinutes: 20,
            avgOutageChangeFailureRecoveryMinutesOptions: {
                min: 1,
                max: 200,
                height: 12,
                tooltipStyle: {
                    "backgroundColor": "#393f50",
                    "borderColor": "#393f50"
                },
                processStyle: {"backgroundColor": "#2d455d"},
                bgStyle: {"backgroundColor": "#a8b7c6"}
            },
            changeFailuresPerCent: 10,
            changeFailuresPerCentOptions: {
                min: 1,
                max: 100,
                height: 12,
                formatter: "{value}%",
                tooltipStyle: {
                    "backgroundColor": "#393f50",
                    "borderColor": "#393f50"
                },
                processStyle: {"backgroundColor": "#2d455d"},
                bgStyle: {"backgroundColor": "#a8b7c6"}
                // interval: 5,
            },
            efficiencyGain: 0.93,
        },
        activeChartCategoryIndex: 0,
        // routerTransitionAfterEnter: function (el) {
        //     window.scrollTo(0,1);
        //     window.scrollTo(0,0);
        // },
        showForm: !isSuccess,
        showFormSuccess: isSuccess,
        form: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            company: '',
            job_title: '',
            country: '',
            state: '',
        },
        countries,
        us_states,
        canada_provinces,
        allowFormSend: true,
        testForm: false,
        errorEmailFreeDomain: false,
    },

    computed: {

        costAuditReporting() {
            return Math.round(this.costOfLabor * (this.auditReporting.minutes / 60) * this.auditReporting.reports * this.auditReporting.securedObjects);
        },
        costAuditReportingWithFiremon() {
            return Math.round(this.costAuditReporting * (1 - this.auditReporting.efficiencyGain));
        },
        savedAuditReportingWithFiremon() {
            return this.costAuditReporting - this.costAuditReportingWithFiremon;
        },

        costRulesChanges() {
            return Math.round(this.costOfLabor * (this.rulesChanges.minutes / 60) * this.rulesChanges.changesPerMonth);
        },
        costRulesChangesWithFiremon() {
            return Math.round(this.costRulesChanges * (1 - this.rulesChanges.efficiencyGain));
        },
        savedRulesChangesWithFiremon() {
            return this.costRulesChanges - this.costRulesChangesWithFiremon;
        },

        costCloudProvisioning() {
            return Math.round(this.costOfLabor * (this.cloudProvisioning.minutes / 60) * this.cloudProvisioning.intancesPerMonth);
        },
        costCloudProvisioningWithFiremon() {
            return Math.round(this.costCloudProvisioning * (1 - this.cloudProvisioning.efficiencyGain));
        },
        savedCloudProvisioningWithFiremon() {
            return this.costCloudProvisioning - this.costCloudProvisioningWithFiremon;
        },

        costOutages() {
            return Math.round(
                (
                    (this.outages.changeWindowsPerMonth * this.outages.avgOutageWindowMinutes / 60) + 
                    (this.outages.changeWindowsPerMonth * this.outages.avgOutageChangeFailureRecoveryMinutes / 60 * this.outages.changeFailuresPerCent / 100)
                ) * this.costOfLabor
            );
        },
        costOutagesWithFiremon() {
            return Math.round(this.costOutages * (1 - this.outages.efficiencyGain));
        },
        savedOutagesWithFiremon() {
            return this.costOutages - this.costOutagesWithFiremon;
        },

        totalCosts() {
            return this.costAuditReporting + this.costRulesChanges + this.costCloudProvisioning + this.costOutages;
        },
        totalCostsWithFiremon() {
            return this.costAuditReportingWithFiremon + this.costRulesChangesWithFiremon + this.costCloudProvisioningWithFiremon + this.costOutagesWithFiremon;
        },
        totalSavedWithFiremon() {
            return this.savedAuditReportingWithFiremon + this.savedRulesChangesWithFiremon + this.savedCloudProvisioningWithFiremon + this.savedOutagesWithFiremon;
        },

        donutChartOptions() {
            return [
                this.savedAuditReportingWithFiremon,
                this.savedRulesChangesWithFiremon,
                this.savedCloudProvisioningWithFiremon,
                this.savedOutagesWithFiremon,
            ];
        },

        download_PDF_URL() {
            var $this = this;
            return 'https://firemon.kubis.ro/pdf?' + $.param({
                first_name: $this.form.first_name,
                last_name: $this.form.last_name,
                email: $this.form.email,
                phone: $this.form.phone,
                company: $this.form.company,
                state: $this.form.state,
                job_title: $this.form.job_title,
                country: $this.form.country,
                costOfLabor: $this.costOfLabor,
                a1: $this.auditReporting.reports,
                a2: $this.auditReporting.securedObjects,
                a3: $this.auditReporting.minutes,
                b1: $this.rulesChanges.changesPerMonth,
                b2: $this.rulesChanges.minutes,
                c1: $this.cloudProvisioning.intancesPerMonth,
                c2: $this.cloudProvisioning.minutes,
                d1: $this.outages.changeWindowsPerMonth,
                d2: $this.outages.avgOutageWindowMinutes,
                d3: $this.outages.avgOutageChangeFailureRecoveryMinutes,
                d4: $this.outages.changeFailuresPerCent,
                totalSavedWithFiremon: $this.totalSavedWithFiremon,
                savedAuditReportingWithFiremon: $this.savedAuditReportingWithFiremon,
                savedRulesChangesWithFiremon: $this.savedRulesChangesWithFiremon,
                savedCloudProvisioningWithFiremon: $this.savedCloudProvisioningWithFiremon,
                savedOutagesWithFiremon: $this.savedOutagesWithFiremon,
                env: $this.env,
            });
        },

        web_preview_PDF_URL() {
            return this.download_PDF_URL + '&web=1';
        }

    },

    watch: {
        'auditReporting.minutes'() {
            this.activeChartCategoryIndex = 0;
        },
        'auditReporting.reports'() {
            this.activeChartCategoryIndex = 0;
        },
        'auditReporting.securedObjects'() {
            this.activeChartCategoryIndex = 0;
        },

        'rulesChanges.minutes'() {
            this.activeChartCategoryIndex = 1;
        },
        'rulesChanges.changesPerMonth'() {
            this.activeChartCategoryIndex = 1;
        },

        'cloudProvisioning.minutes'() {
            this.activeChartCategoryIndex = 2;
        },
        'cloudProvisioning.intancesPerMonth'() {
            this.activeChartCategoryIndex = 2;
        },

        'outages.changeWindowsPerMonth'() {
            this.activeChartCategoryIndex = 3;
        },
        'outages.avgOutageWindowMinutes'() {
            this.activeChartCategoryIndex = 3;
        },
        'outages.avgOutageChangeFailureRecoveryMinutes'() {
            this.activeChartCategoryIndex = 3;
        },
        'outages.changeFailuresPerCent'() {
            this.activeChartCategoryIndex = 3;
        },

        'form.email'() {
            this.errorEmailFreeDomain = false;
        },

    },

    methods: {
        mouseoverCategoryBar(index) {
            this.activeChartCategoryIndex = index;
        },
        clickShowForm() {
            this.showForm = true;
        },
        submitForm() {
            var $this = this;
            var form = $('#form-pardot');
            $this.errorEmailFreeDomain = false;
            this.$validator.validate().then(valid => {
                if (valid && $this.allowFormSend) {
                    $this.allowFormSend = false;
                    $.ajax({
                        url: window.formAction,
                        method: 'post',
                        data: form.serialize(),
                        success(data, textStatus, request) {
                            // console.log(request);
                            if (data === 'error') {
                                $this.errorEmailFreeDomain = true;
                                return false;
                            }
                            $this.showForm = false;
                            $this.showFormSuccess = true;
                            $this.saveDataToLocalStorage();
                            localStorage.setItem('pageYOffset', window.pageYOffset);
                            localStorage.setItem('download_PDF_URL', $this.download_PDF_URL);
                            window.location.href = window.location.origin + window.location.pathname + '?success';
                        },
                        complete(req) {
                            // console.log(req);
                            $this.allowFormSend = true;
                        }
                    });
                }
            });
        },
        handleQueriedRequest() {
            if (window.location.search.indexOf('company') !== -1) {
                let query = Helpers.URL_Params_to_Obj();
                this.form.first_name = query.first_name;
                this.form.last_name = query.last_name;
                this.form.email = query.email;
                this.form.phone = query.phone;
                this.form.company = query.company;
                this.form.state = query.state;
                this.form.job_title = query.job_title;
                this.form.country = query.country;
                this.costOfLabor = parseInt(query.costOfLabor);
                this.auditReporting.reports = parseInt(query.a1);
                this.auditReporting.securedObjects = parseInt(query.a2);
                this.auditReporting.minutes = parseInt(query.a3);
                this.rulesChanges.changesPerMonth = parseInt(query.b1);
                this.rulesChanges.minutes = parseInt(query.b2);
                this.cloudProvisioning.intancesPerMonth = parseInt(query.c1);
                this.cloudProvisioning.minutes = parseInt(query.c2);
                this.outages.changeWindowsPerMonth = parseInt(query.d1);
                this.outages.avgOutageWindowMinutes = parseInt(query.d2);
                this.outages.avgOutageChangeFailureRecoveryMinutes = parseInt(query.d3);
                this.outages.changeFailuresPerCent = parseInt(query.d4);
            }
        },
        saveDataToLocalStorage() {
            localStorage.setItem('costOfLabor', this.costOfLabor);
            localStorage.setItem('a1', this.auditReporting.reports);
            localStorage.setItem('a2', this.auditReporting.securedObjects);
            localStorage.setItem('a3', this.auditReporting.minutes);
            localStorage.setItem('b1', this.rulesChanges.changesPerMonth);
            localStorage.setItem('b2', this.rulesChanges.minutes);
            localStorage.setItem('c1', this.cloudProvisioning.intancesPerMonth);
            localStorage.setItem('c2', this.cloudProvisioning.minutes);
            localStorage.setItem('d1', this.outages.changeWindowsPerMonth);
            localStorage.setItem('d2', this.outages.avgOutageWindowMinutes);
            localStorage.setItem('d3', this.outages.avgOutageChangeFailureRecoveryMinutes);
            localStorage.setItem('d4', this.outages.changeFailuresPerCent);
        },

        loadDataFromLocalStorage() {
            this.costOfLabor = parseInt(localStorage.getItem('costOfLabor'));
            this.auditReporting.reports = parseInt(localStorage.getItem('a1'));
            this.auditReporting.securedObjects = parseInt(localStorage.getItem('a2'));
            this.auditReporting.minutes = parseInt(localStorage.getItem('a3'));
            this.rulesChanges.changesPerMonth = parseInt(localStorage.getItem('b1'));
            this.rulesChanges.minutes = parseInt(localStorage.getItem('b2'));
            this.cloudProvisioning.intancesPerMonth = parseInt(localStorage.getItem('c1'));
            this.cloudProvisioning.minutes = parseInt(localStorage.getItem('c2'));
            this.outages.changeWindowsPerMonth = parseInt(localStorage.getItem('d1'));
            this.outages.avgOutageWindowMinutes = parseInt(localStorage.getItem('d2'));
            this.outages.avgOutageChangeFailureRecoveryMinutes = parseInt(localStorage.getItem('d3'));
            this.outages.changeFailuresPerCent = parseInt(localStorage.getItem('d4'));
        },
    },

    mounted () {
        var $this = this;

        this.handleQueriedRequest();

        if (this.testForm) {
            this.form.first_name = 'test';
            this.form.last_name = 'last name';
            this.form.email = 'tudor.sava@kubisinteractive.com';
            this.form.phone = '0740111222';
            this.form.company = 'Kubis';
            this.form.state = '';
            this.form.job_title = 'web dev';
            this.form.country = 'Argentina';
        }

        $.fn.forceNumericOnly =
        function()
        {
            return this.each(function()
            {
                $(this).keydown(function(e)
                {
                    var key = e.charCode || e.keyCode || 0;
                    // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
                    // home, end
                    return (
                        key == 8 ||
                        key == 9 ||
                        key == 13 ||
                        key == 46 ||
                        key == 110 ||
                        key == 190 ||
                        (key >= 35 && key <= 40) ||
                        (key >= 48 && key <= 57)) ||
                        (key >= 96 && key <= 105);
                });
            });
        };

        this.$nextTick(() => {

            var $this = this;

            if (isSuccess) {
                this.loadDataFromLocalStorage();
                setTimeout(() => {
                    $('body, html').animate({
                        scrollTop: parseInt(localStorage.getItem('pageYOffset'))
                    }, 1);
                }, 200);
                setTimeout(() => {
                    window.location.href = localStorage.getItem('download_PDF_URL');
                }, 700);
            }

            $('.input-calculator').forceNumericOnly();

            $('.control').click(function(e) {
                var categoryCard = $(e.currentTarget).parent();
                categoryCard.toggleClass('open');
                app.$children
                    .filter(child => child.$options.name === 'VueSliderComponent')
                    .forEach(slider => slider.refresh());
                if (categoryCard.hasClass('open')) {
                    $this.activeChartCategoryIndex = parseInt(categoryCard.attr('data-chart-index'));
                    categoryCard.find('.info-circle').removeClass('animate').addClass('animate');
                }
            });

            $('[data-toggle="tooltip"]').tooltip();
            // $('[data-toggle="popover"]').popover();

            // if it's not the pdf page AND it's not the LP success AND it's no a LP queried request from PDF edit link
            if ($('.pdf-wrap').length === 0 &&
                 window.location.search.indexOf('?success') === -1 &&
                 window.location.search.indexOf('company') === -1
            ) {
                setTimeout(() => {
                    if ($(window).width() > 992) {
                        // desktop
                        $('body, html').animate({
                            scrollTop: $('.hero').next().offset().top
                        }, 400);
                        setTimeout(() => {
                            $('.control').eq(0).click();
                            setTimeout(() => {
                                Helpers.animateNumber($this, 150, 1000);
                                setTimeout(() => {
                                    Helpers.animateNumber($this, 100, 400);
                                }, 1000);
                            }, 300);
                        }, 700);
                    }
                    else {
                        // mobile
                        $('.control').eq(0).click();
                        $('body, html').animate({
                            scrollTop: $('.category-card--rules-changes').offset().top - 130
                        }, 400);
                        setTimeout(() => {
                            setTimeout(() => {
                                Helpers.animateNumber($this, 160, 1000);
                                setTimeout(() => {
                                    Helpers.animateNumber($this, 120, 400);
                                }, 1000);
                            }, 300);
                        }, 700);
                    }
                }, 1000);
            }

        });

    },
}).$mount('#app');


// WEBPACK FOOTER //
// ./resources/assets/js/app-roi-calculator.js